<template>
  <div class="search-options" :class="{ desktop: $isDesktop }">
    <div>
      <p>
        <img
          class="icon"
          src="@/assets/images/calendar-blue.svg"
          :alt="$t('Dates')"
          width="25"
          height="25"
        />
        <translate v-if="!dates"> Dates </translate>
        <search-wizard-homepage-banner-options-dates :dates="dates" />
      </p>
      <p>
        <img
          class="family icon"
          src="@/assets/images/family.svg"
          :alt="$t('Persons')"
          width="25"
          height="20"
        />
        <translate v-if="!party || !areAdultsInUrl"> Persons </translate>
        <search-wizard-homepage-banner-options-party v-else :party="party" />
      </p>
    </div>
    <base-button class="primary">
      <translate>Search</translate>
    </base-button>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { SearchParty } from '../../../search/schemas'
import { ArriveDepartIso } from '../../../search/types'

@Component
class SearchWizardHomepageBannerOptions extends Vue {
  @Prop({ required: true, type: [Object, String] })
  party: SearchParty | ''

  @Prop({ required: true, type: [Object, String] })
  dates: ArriveDepartIso | ''

  get areAdultsInUrl() {
    return !!this.$route.query.adults
  }
}

export default toNative(SearchWizardHomepageBannerOptions)
</script>

<style scoped>
.search-options {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.search-options > div {
  margin-left: 0.8em;
}

.icon {
  margin: 0 0.3em 0 0;
  width: 1.4em;
  flex-shrink: 0;
}

.icon.family {
  opacity: 0.5;
  filter: saturate(0.5) hue-rotate(97deg);
}

.search-options p {
  color: var(--colour-wcag-blue);
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}

.search-options p:first-of-type {
  margin: 0 0 0.3em 0;
  align-items: center;
}

.search-options p > span {
  flex-shrink: 1;
}

.primary {
  padding: 0.4em 1em 0.4em;
  box-shadow: 0 0.2em var(--colour-dark-green);
  font-weight: normal;
}

/* desktop & tablet */
.search-options.desktop > div {
  display: flex;
  margin: 0 1em 0 0;
}

.search-options.desktop > div p {
  background: white;
  border-radius: 9em;
  font-size: 1.3em;
  padding: 0.5em 1em;
  margin: 0;
  display: flex;
}

.search-options.desktop p:first-of-type {
  margin: 0 1em 0 0;
}
</style>
